
import { updateDiagramStepTooltip, getDiagramStepTooltip } from '@process-advisor/process-miner/processMiner/processMiner';

export type StepTooltipProps = {
    tasks?: boolean;
    avg_duration?: boolean;
    med_duration?: boolean;
    min_duration?: boolean;
    max_duration?: boolean;
    total?: boolean;
    deviation?: boolean;
    comments_internal?: boolean,
    avg_comments_internal?: boolean,
    comments_customer?: boolean,
    avg_comments_customer?: boolean,
    worklogs?: boolean,
    avg_worklogs?: boolean,
    perc_comments_internal?: boolean,
    perc_comments_customer?: boolean,
    perc_worklogs?: boolean,
    total_timespent?: boolean,
    avg_timespent?: boolean,
}

export const changeStepTooltip = ({
    tasks,
    avg_duration,
    med_duration,
    min_duration,
    max_duration,
    total,
    deviation,
    comments_internal,
    avg_comments_internal,
    comments_customer,
    avg_comments_customer,
    worklogs,
    avg_worklogs,
    perc_comments_internal,
    perc_comments_customer,
    perc_worklogs,
    total_timespent,
    avg_timespent,
}: StepTooltipProps) => updateDiagramStepTooltip({
    tasks,
    avg_duration,
    med_duration,
    min_duration,
    max_duration,
    total,
    deviation,
    comments_internal,
    avg_comments_internal,
    comments_customer,
    avg_comments_customer,
    worklogs,
    avg_worklogs,
    perc_comments_internal,
    perc_comments_customer,
    perc_worklogs,
    total_timespent,
    avg_timespent,
});

export const getStepTooltip = (): StepTooltipProps => getDiagramStepTooltip();
